import { UPDATE, fetchUtils } from 'react-admin';
import postgrestProvider from './ra-data-postgrest';
import mongooseProvider from './ra-data-mongoose';
import { updatePreaffectation } from './resources/preaffectation/functions/updatePreaffectation';

const mongooseResources = [
  'availability',
  'issue_report',
  'logs',
  'mission_report',
];

export default (type, resource, params) => {
  if (mongooseResources.includes(resource)) {
    return mongooseProvider(type, resource, params);
  }

  // Préaffectation : relecture puis PATCH conditionnel des seuls champs
  // modifiés, jamais d'écrasement d'une modification faite ailleurs
  // (plan 070b, décision PO Q19).
  if (resource === 'preaffectation' && type === UPDATE) {
    return updatePreaffectation(params, { fetchJson: fetchUtils.fetchJson });
  }

  return postgrestProvider(type, resource, params);
};
